/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_View_Diet_LeftInputs */

const en_portal_view_diet_left = /** @type {(inputs: Portal_View_Diet_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Left`)
};

const pl_portal_view_diet_left = /** @type {(inputs: Portal_View_Diet_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zostało`)
};

/**
* | output |
* | --- |
* | "Left" |
*
* @param {Portal_View_Diet_LeftInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_view_diet_left = /** @type {((inputs?: Portal_View_Diet_LeftInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_View_Diet_LeftInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_view_diet_left(inputs)
	return en_portal_view_diet_left(inputs)
});